// COMTRUECamera.js
import { COMTRUEVAR } from '../default/ocr_variables'
import {
    sendPostMessageCameraInit,
    closeThis,
    sendPostMessageCameraAccess,
    sendPostMessageClose,
} from '../default/common'
import { createCOMTRUEEncryptUtils } from '../encrypt/encryptUtil'
/**
 * WebGL 랜더링 추가
 * WebGL Video Renderer
 * 비디오 요소를 텍스처로 변환하여 Canvas에 GPU 가속으로 그립니다.
 */
var SimpleWebGLRenderer = {
    gl: null,
    program: null,
    texture: null,
    video: null,
    canvas: null,
    isRunning: false,

    init: function (canvas, video) {
        this.canvas = canvas;
        this.video = video;

        // 1. WebGL 컨텍스트 획득 (webgl2 우선, 없으면 webgl)
        this.gl = canvas.getContext('webgl', {alpha: false, preserveDrawingBuffer: true}) ||
            canvas.getContext('experimental-webgl', {alpha: false, preserveDrawingBuffer: true});

        if (!this.gl) {
            console.error("WebGL not supported");
            return false;
        }

        // 2. 쉐이더 컴파일 (Vertex & Fragment)
        const vsSource = `
            attribute vec2 a_position;
            attribute vec2 a_texCoord;
            varying vec2 v_texCoord;
            void main() {
                gl_Position = vec4(a_position, 0, 1);
                v_texCoord = a_texCoord;
            }
        `;

        // Y축 반전 없이 그대로 출력 (비디오 텍스처는 일반적으로 상하 반전 필요 없음)
        const fsSource = `
            precision mediump float;
            uniform sampler2D u_image;
            varying vec2 v_texCoord;
            void main() {
                gl_FragColor = texture2D(u_image, v_texCoord);
            }
        `;

        const vertexShader = this.createShader(this.gl.VERTEX_SHADER, vsSource);
        const fragmentShader = this.createShader(this.gl.FRAGMENT_SHADER, fsSource);
        this.program = this.createProgram(vertexShader, fragmentShader);
        this.gl.useProgram(this.program);

        // 3. 버퍼 설정 (화면 꽉 채우는 사각형)
        const positionBuffer = this.gl.createBuffer();
        this.gl.bindBuffer(this.gl.ARRAY_BUFFER, positionBuffer);
        this.gl.bufferData(this.gl.ARRAY_BUFFER, new Float32Array([
            -1, -1, -1, 1, 1, -1,
            1, -1, -1, 1, 1, 1,
        ]), this.gl.STATIC_DRAW);

        const positionLocation = this.gl.getAttribLocation(this.program, "a_position");
        this.gl.enableVertexAttribArray(positionLocation);
        this.gl.vertexAttribPointer(positionLocation, 2, this.gl.FLOAT, false, 0, 0);

        const texCoordBuffer = this.gl.createBuffer();
        this.gl.bindBuffer(this.gl.ARRAY_BUFFER, texCoordBuffer);
        // 텍스처 좌표 (0.0 ~ 1.0)
        this.gl.bufferData(this.gl.ARRAY_BUFFER, new Float32Array([
            0, 1, 0, 0, 1, 1,
            1, 1, 0, 0, 1, 0,
        ]), this.gl.STATIC_DRAW);

        const texCoordLocation = this.gl.getAttribLocation(this.program, "a_texCoord");
        this.gl.enableVertexAttribArray(texCoordLocation);
        this.gl.vertexAttribPointer(texCoordLocation, 2, this.gl.FLOAT, false, 0, 0);

        // 4. 텍스처 생성
        this.texture = this.gl.createTexture();
        this.gl.bindTexture(this.gl.TEXTURE_2D, this.texture);

        // 텍스처 파라미터 설정 (NPOT 텍스처 지원을 위해 CLAMP_TO_EDGE 필수)
        this.gl.texParameteri(this.gl.TEXTURE_2D, this.gl.TEXTURE_WRAP_S, this.gl.CLAMP_TO_EDGE);
        this.gl.texParameteri(this.gl.TEXTURE_2D, this.gl.TEXTURE_WRAP_T, this.gl.CLAMP_TO_EDGE);
        this.gl.texParameteri(this.gl.TEXTURE_2D, this.gl.TEXTURE_MIN_FILTER, this.gl.LINEAR);
        this.gl.texParameteri(this.gl.TEXTURE_2D, this.gl.TEXTURE_MAG_FILTER, this.gl.LINEAR);

        return true;
    },

    render: function () {
        if (!this.gl || !this.video || this.video.readyState < this.video.HAVE_CURRENT_DATA) {
            return;
        }

        // 뷰포트 설정 (Canvas 크기에 맞춤)
        this.gl.viewport(0, 0, this.canvas.width, this.canvas.height);

        // 비디오 프레임을 텍스처로 업로드 (CPU 복사 없이 GPU가 직접 가져감)
        this.gl.bindTexture(this.gl.TEXTURE_2D, this.texture);
        this.gl.texImage2D(this.gl.TEXTURE_2D, 0, this.gl.RGBA, this.gl.RGBA, this.gl.UNSIGNED_BYTE, this.video);

        // 그리기
        this.gl.drawArrays(this.gl.TRIANGLES, 0, 6);
    },

    createShader: function (type, source) {
        const shader = this.gl.createShader(type);
        this.gl.shaderSource(shader, source);
        this.gl.compileShader(shader);
        if (!this.gl.getShaderParameter(shader, this.gl.COMPILE_STATUS)) {
            console.error(this.gl.getShaderInfoLog(shader));
            this.gl.deleteShader(shader);
            return null;
        }
        return shader;
    },

    createProgram: function (vertexShader, fragmentShader) {
        const program = this.gl.createProgram();
        this.gl.attachShader(program, vertexShader);
        this.gl.attachShader(program, fragmentShader);
        this.gl.linkProgram(program);
        return program;
    },
    checkBlackScreen: function () {
        if (!this.gl) return false;

        const pixels = new Uint8Array(4);
        const x = this.canvas.width / 2;
        const y = this.canvas.height / 2;

        this.gl.readPixels(x, y, 1, 1, this.gl.RGBA, this.gl.UNSIGNED_BYTE, pixels);

        console.log(`[WebGL Check] RGBA: ${pixels[0]}, ${pixels[1]}, ${pixels[2]}, ${pixels[3]}`);
        //alert(`[WebGL Check] RGBA: ${pixels[0]}, ${pixels[1]}, ${pixels[2]}, ${pixels[3]}`);
        // R, G, B가 10 이하(거의 검정)라면 검은 화면으로 판단
        if (pixels[0] < 10 && pixels[1] < 10 && pixels[2] < 10) {
            return true; // 검은 화면임 (재시도 필요)
        }
        return false; // 화면 나옴
    },
    // [추가] WebGL 리소스 해제 및 컨텍스트 종료 함수
    destroy: function () {
        if (!this.gl) return;

        try {
            // 1. 프로그램 및 쉐이더 삭제
            if (this.program) {
                this.gl.deleteProgram(this.program);
            }

            // 2. 텍스처 삭제
            if (this.texture) {
                this.gl.deleteTexture(this.texture);
            }

            // 3. 버퍼 삭제 (필요 시 기존 init에서 버퍼를 변수에 저장해둬야 완벽하지만, 컨텍스트 날리면 대부분 해결됨)

            // 4. 컨텍스트 강제 상실 (가장 중요)
            // 브라우저에게 "나 이 WebGL 안 써"라고 알려주는 확장 기능입니다.
            const ext = this.gl.getExtension('WEBGL_lose_context');
            if (ext) {
                ext.loseContext();
            }
        } catch (e) {
            console.error("WebGL Cleanup Failed:", e);
        } finally {
            this.gl = null;
            this.program = null;
            this.texture = null;
            this.video = null;
            this.canvas = null;
            this.isRunning = false;
        }
    }

};
export const useComtrueCamera = () => {
    // 암호화 함수 호출관련 추가
    const COMTRUEEncryptUtils = createCOMTRUEEncryptUtils()

    // 아이폰 지원 언어(후면카메라) 상수
    const IphoneSupportedLanguages = [
        { country: 'korea', word: '후면 카메라' },
        { country: 'english', word: 'Back Camera' },
        { country: 'chinese(simplified)', word: '后置相机' },
        { country: 'chinese(traditional)', word: '後置相機' },
        { country: 'chinese(traditional,hongkong)', word: '後置鏡頭' },
        { country: 'japanese', word: '背面カメラ' },
        { country: 'spanish', word: 'Cámara trasera' },
        { country: 'french', word: 'Caméra arrière' },
        { country: 'german', word: 'Rückkamera' },
        { country: 'russian', word: 'Камера на задней панели' },
        { country: 'portuguese', word: 'Câmera Traseira' },
        { country: 'italian', word: 'Fotocamera (posteriore)' },
        { country: 'turkey', word: 'Arka Kamera' },
        { country: 'arab', word: 'Camera aan achterzijde' },
        { country: 'thailand', word: 'กล้องด้านหลัง' },
        { country: 'sweden', word: 'Kamera på baksida' },
        { country: 'denmark', word: 'Bagsidekamera' },
        { country: 'vietnam', word: 'Camera mặt sau' },
        { country: 'norway', word: 'Kamera bak' },
        { country: 'finland', word: 'Tylny aparat' },
        { country: 'indonesia', word: 'Kamera Belakang' },
        { country: 'greece', word: 'Πίσω κάμερα' },
        { country: 'rumania', word: 'Cameră spate' },
        { country: 'hungary', word: 'Hátsó kamera' },
        { country: 'czech republic', word: 'Zadní fotoaparát' },
        { country: 'catalonia', word: 'Càmera posterior' },
        { country: 'slovakia', word: 'Zadná kamera' },
        { country: 'ukraine', word: 'Задня камера' },
        { country: 'croatia', word: 'Stražnja kamera' },
        { country: 'malaysia', word: 'Kamera Belakang' },
        { country: 'hindi', word: 'बैक कैमरा' },
        { country: 'kazakhstan', word: 'Артқы камера' },
        { country: 'bulgaria', word: 'Задна камера' },
    ]

    // [26.01.23] 상태 관리용 변수 추가
    let useWebGL = false
    let ocrLoopStarted = false
    let blackCount = 0

    const method = {}
    const elements = []
    let video = null
    let canvas = null
    let context = null
    let user = false

    const play = async (videoElement, canvasElement, isUser) => {
        if (COMTRUEVAR.debugModeComtrue) {
            console.log('[ComtrueCamera.play] START')
        }

        navigator.getUserMedia =
            navigator.mediaDevices.getUserMedia ||
            navigator.getUserMedia ||
            navigator.webkitGetUserMedia ||
            navigator.mozGetUserMedia ||
            navigator.msGetUserMedia

        if (navigator.getUserMedia) {
            if (!videoElement) {
                throw 'video is undefined'
            }

            video = videoElement
            canvas = canvasElement
            //context = null

            // [Patch] WebGL 초기화 시도
           /* useWebGL = SimpleWebGLRenderer.init(canvas, video)
            alert("useWebGL 초기화 : " + useWebGL);
            if (!useWebGL) {
                console.log('WebGL 초기화 실패, Fallback to 2D')
                // context = canvas.getContext('2d'); // 필요 시 2D 컨텍스트 활성화
            }*/

            return settingInfo(isUser)
        } else {
            if (COMTRUEVAR.debugModeComtrue) {
                console.log('getUserMedia not supported')
            }
            setTimeout(() => {
                // fixme [2025.06.09] COMTRUECommon 함수 호출방식 수정
                sendPostMessageCameraInit()
                closeThis('카메라에 접근 할 수 없습니다. 다시 시도해주세요.')
            }, 333)
        }
    }

    const stop = () => {
        if (COMTRUEVAR.debugModeComtrue) {
            console.log('[ComtrueCamera.stop] START')
        }

        // 1. WebGL 정리 
        if (useWebGL) {
            SimpleWebGLRenderer.destroy();
            useWebGL = false;
        }

        // 2. 비디오 스트림 정리
        if (video?.srcObject) {
            const stream = video.srcObject
            const tracks = stream.getTracks()
            tracks.forEach((track) => {
                try {
                    stream.removeTrack(track)
                } catch (e) {}
                track.stop()
            })

            try {
                video.srcObject = null;
            } catch (e) {
                console.log('ERROR video.srcObject :: ' + e)
            }

            // src 비우기
            try {
                video.removeAttribute('src');
                video.load(); // 메모리 해제를 위해 load 호출
            } catch (e) {}
        }
    }
    const change = (isUser) => {
        if (COMTRUEVAR.debugModeComtrue) {
            console.log('[ComtrueCamera.change] START')
        }
        if (user !== isUser) {
            settingInfo(isUser)
        }
    }

    const done = (data) => {
        if (COMTRUEVAR.debugModeComtrue) {
            console.log('[ComtrueCamera.done] START')
        }
        method.done = data
        if (video?.srcObject) {
            method.done()
        }
    }

    const draw = (data) => {
        if (COMTRUEVAR.debugModeComtrue) {
            console.log('[ComtrueCamera.draw] START')
        }
        method.draw = data
    }

    const _play = async (isUser, device, customConstraints) => {
        if (COMTRUEVAR.debugModeComtrue) {
            console.log('[ComtrueCamera._play] START')
        }

        stopCameraStream()
        user = isUser

        // [26.01.23] self -> that으로 변경하여 ESLint 에러 회피 및 필요한 객체 참조 저장
        const that = {
            video: video,
            canvas: canvas
        };

        const userAgent = navigator.userAgent.toLowerCase()
        let constraints = {
            audio: false,
        }

         let deviceNullRetryCheck = false
            let comtrueVideoResolutionTarget = 'height'
            let comtrueVideoResolutionMin = 1080
            let comtrueVideoResolutionIdeal = 1440
            let comtrueVideoResolutionMax = 1440


         if (customConstraints) {
            constraints = customConstraints;
            if (COMTRUEVAR.debugModeComtrue) console.log("[ComtrueCamera._play] customConstraints fallback");
        } else {
        
            if (isUser) {
                constraints = {
                    video: {
                        facingMode: 'user',
                    },
                }
            } else {
                if (device?.deviceId?.length > 0) {
                    constraints = {
                        video: {
                            deviceId: device.deviceId,
                        },
                    }
                } else {
                    const check = sessionStorage.getItem('retry_check_comtrue')
                    if (check === null || check === 'null') {
                        deviceNullRetryCheck = true
                        sessionStorage.setItem('retry_check_comtrue', 'true')
                    }
                    constraints = {
                        video: {
                            facingMode: 'environment',
                        },
                    }
                }
            }

            constraints.whiteBalanceMode = false

            if (isUser) {
                comtrueVideoResolutionTarget = 'width'
                comtrueVideoResolutionMin = 1280
                comtrueVideoResolutionIdeal = 1920
                comtrueVideoResolutionMax = 1920
            } else {
                if (userAgent.indexOf('android') > -1) {
                    comtrueVideoResolutionMin = 1080
                    comtrueVideoResolutionIdeal = 1441
                    comtrueVideoResolutionMax = 1441

                   let videoConstraints = {
                        facingMode: {ideal: "environment"},
                        width: {min: 1920, ideal: 3840},
                        height: {min: 1080, ideal: 2160}
                    };

                    // 앞서 찾은 후면 deviceId를 'exact'로 강제 결합
                    if (device && device.deviceId) {
                        videoConstraints.deviceId = {exact: device.deviceId};
                    }

                    // 기존 constraints.video에 덮어쓰기
                    constraints.video = videoConstraints;
                } else{
                    // 아이폰 및 기타 (기존 로직 유지)
                    let iosConstraints = {
                        facingMode: "environment"
                    };

                    if (device && device.deviceId) {
                        iosConstraints.deviceId = device.deviceId;
                    }

                    // 기존 아이폰/PC용 해상도 설정 (Height 기준)
                    iosConstraints.height = {
                        min: 1080,
                        ideal: 1440,
                        max: 1440
                    };

                    constraints.video = iosConstraints;
                }

                if (
                    typeof COMTRUEVAR.cardTypeVarComtrue !== 'undefined' &&
                    COMTRUEVAR.cardTypeVarComtrue != null
                ) {
                    if (
                        typeof COMTRUEVAR.comtrueCustomVideoResolution !==
                            'undefined' &&
                        COMTRUEVAR.comtrueCustomVideoResolution != null
                    ) {
                        if (
                            COMTRUEVAR.cardTypeVarComtrue === 'usim' &&
                            COMTRUEVAR.comtrueCustomVideoResolution === 'ktmmobile'
                        ) {
                            if (userAgent.indexOf('android') > -1) {
                                comtrueVideoResolutionIdeal = 2161
                                comtrueVideoResolutionMax = 2161
                            } else {
                                comtrueVideoResolutionIdeal = 2160
                                comtrueVideoResolutionMax = 2160
                            }
                        }
                    }
                }
            }
        }

        /*constraints.video[comtrueVideoResolutionTarget] = {
            min: comtrueVideoResolutionMin,
            ideal: comtrueVideoResolutionIdeal,
            max: comtrueVideoResolutionMax,
        }*/

        try {
            const stream = await navigator.mediaDevices.getUserMedia(
                constraints
            )

            if (deviceNullRetryCheck) {
                sessionStorage.setItem('retry_check_comtrue', 'false')
                window.location.reload()
                return
            }

            setTimeout(() => {
                video.srcObject = stream
                const track = stream.getVideoTracks()[0];
                const settings = track.getSettings();

                if (COMTRUEVAR.debugModeComtrue) {
                    console.log(`Resolution: ${settings.width} x ${settings.height}`);
                }

                COMTRUEVAR.COM_WIDTH = settings.width;
                COMTRUEVAR.COM_HEIGHT = settings.height;

                // 해상도가 낮을 경우 CSS 높이 조정 (1920x1080 이하)
                const longSide = Math.max(settings.width, settings.height);
                const shortSide = Math.min(settings.width, settings.height);
                if (longSide <= 1920 && shortSide <= 1080) {
                    video.style.height = "100%";
                }

                // [26.01.23] 안드로이드 블랙스크린 감지 (WebGL 사용)
                if (userAgent.indexOf("android") > -1 && !customConstraints) {
                    setTimeout(() => {
                        let isFail = false;
                        // 검사용 임시 캔버스 생성 (메인 캔버스 건드리지 않음)
                        const checkCanvas = document.createElement('canvas');
                        checkCanvas.width = that.video.videoWidth / 10; // 크기 줄여서 성능 확보
                        checkCanvas.height = that.video.videoHeight / 10;
                        // 임시 캔버스로 WebGL 초기화 & 검사
                        if(SimpleWebGLRenderer.init(checkCanvas, that.video)){
                            SimpleWebGLRenderer.render(); // 그리기
                            if (SimpleWebGLRenderer.checkBlackScreen()) {
                                isFail = true;
                                blackCount += 1;
                            }
                        }

                        if (isFail) {
                            COMTRUEVAR.blackScreenRetryFlag = "CAMERA_LOG_blackScreen";
                            console.log("[_play] Black Screen detected! Retrying with lower resolution...");
                            video.style.height = "100%";
                            _retryWithLowerResolution(isUser, device);
                        } else {
                            console.log("[_play] Camera Status Normal");
                        }
                    }, 555);
                }

                video.onplaying = function () {
                    _draw();

                    if (method.done && !ocrLoopStarted) {
                        console.log("[ComtrueCamera] OCR Loop Started");
                        method.done();
                        ocrLoopStarted = true;
                    }
                    video.onplaying = null;
                };

                video.play();

            }, 333)
        } catch (error) {
            if (COMTRUEVAR.debugModeComtrue) {
                console.log(error.message)
            }

            setTimeout(() => {
                const errorString = (error + '').toLowerCase()
                // fixme [2025.06.09] COMTRUECommon 함수 호출방식 수정
                // [26.01.23] 해상도 지원하지 않는 경우 재시도 로직 추가
                COMTRUEVAR.blackScreenRetryFlag = "CAMERA_LOG_" + error.name;
                if (error.name === "NotReadableError" || errorString === 'overconstrainederror') {
                    if (!customConstraints) {
                        console.log( errorString + " -> Retry with lower resolution");
                        video.style.height = "100%";
                        _retryWithLowerResolution(isUser, device);
                        return;
                    }
                }
                if (errorString.indexOf('over') > -1) {
                    sendPostMessageCameraInit()
                } else if (
                    errorString.indexOf('notallowed') > -1 ||
                    errorString.indexOf('permission') > -1
                ) {
                    sendPostMessageCameraAccess()
                } else {
                    sendPostMessageCameraInit()
                }
                closeThis(
                    '카메라 설정시 오류가 발생했습니다. 처음부터 다시 시도해주세요.'
                )
            }, 333)
        }
    }

    const _draw = () => {
        // video나 srcObject가 없으면 즉시 중단 (재귀 호출 방지)
        if (!video || !video.srcObject || video.paused || video.ended) {
            return;
        }
       
        if (video.readyState >= HTMLMediaElement.HAVE_CURRENT_DATA) {
            // 캔버스 크기 싱크
            if (
                canvas.width !== video.videoWidth ||
                canvas.height !== video.videoHeight
            ) {
                canvas.width = video.videoWidth
                canvas.height = video.videoHeight
            }

            if (useWebGL) {
                SimpleWebGLRenderer.render()
            } else {
                // Legacy 2D Drawing if needed
                // const ctx = canvas.getContext('2d');
                // ctx.drawImage(video, 0, 0);
            }

            if (method.draw != null) {
                method.draw()
            }
        }

        if (video?.srcObject && !video.paused) {
            requestAnimationFrame(_draw)
        }
    }

    // [26.01.23] 재시도 로직 추가 (낮은 해상도로 재시도)
    const _retryWithLowerResolution = (isUser, device) => {
        stopCameraStream()

        const nextConstraints = {
            video: {
                facingMode: 'environment',
                width: { ideal: 1920 },
                height: { ideal: 1080 },
            },
        }

        if (device && device.deviceId) {
            nextConstraints.video.deviceId = { exact: device.deviceId }
        }

        _play(isUser, device, nextConstraints)
    }

    const gotDevice = (deviceInfos, isUser) => {
        if (COMTRUEVAR.debugModeComtrue) {
            console.log('[ComtrueCamera.gotDevice] START')
        }

        const userAgent = navigator.userAgent.toLowerCase()
        deviceInfos = deviceInfos.filter((x) => x.kind === 'videoinput')
        let device = null

        if (!isUser) {
            if (userAgent.indexOf('iphone') > -1) {
                for (let i = 0; i < deviceInfos.length; i++) {
                    const deviceInfo = deviceInfos[i]
                    const isExists = IphoneSupportedLanguages.find(
                        (language) =>
                            language.word.toLowerCase().replace(/ /g, '') ===
                            deviceInfo.label.toLowerCase().replace(/ /g, '')
                    )
                    if (isExists) {
                        device = deviceInfo
                        break
                    }
                }
            } else {
                if (userAgent.indexOf('android') > -1) {
                    try {
                        const deviceInfosCheck = deviceInfos.filter()
                        if (deviceInfosCheck != null) {
                            deviceInfos =
                                deviceInfosCheck[deviceInfosCheck.length - 1]
                        }
                    } catch (e) {}
                }
                device = deviceInfos.pop()
            }
        }
        return device
    }

    const gotStream = async (stream) => {
        if (COMTRUEVAR.debugModeComtrue) {
            console.log('[ComtrueCamera.gotStream] START')
        }
        window.stream = stream
        video.srcObject = stream
        return navigator.mediaDevices.enumerateDevices()
    }

    const settingInfo = async (isUser) => {
        if (COMTRUEVAR.debugModeComtrue) {
            console.log('[ComtrueCamera.settingInfo] START')
        }

        stopCameraStream()

        const constraints = {
            video: {
                facingMode: isUser ? 'user' : 'environment',
            },
        }

        try {
            const stream = await navigator.mediaDevices.getUserMedia(
                constraints
            )
            const deviceInfos = await gotStream(stream)
            const device = await gotDevice(deviceInfos, isUser)
            await _play(isUser, device)
        } catch (error) {
            if (COMTRUEVAR.debugModeComtrue) {
                console.log(error.message)
            }

            setTimeout(() => {
                const errorString = (error + '').toLowerCase()
                // fixme [2025.06.09] COMTRUECommon 함수 호출방식 수정
                if (errorString.indexOf('over') > -1) {
                    sendPostMessageCameraInit()
                } else if (
                    errorString.indexOf('notallowed') > -1 ||
                    errorString.indexOf('permission') > -1
                ) {
                    sendPostMessageCameraAccess()
                } else {
                    sendPostMessageCameraInit()
                }
                closeThis(
                    '신분증 OCR 서비스에서 신분증 촬영을 하시려면, 카메라 접근 허용 후, 다시 시도해주세요.'
                );
            }, 333)
        }
    }

    const stopTrack = () => {
        if (COMTRUEVAR.debugModeComtrue) {
            console.log('[ComtrueCamera.stopTrack] START')
        }
        if (window.stream) {
            window.stream.getTracks().forEach((track) => {
                track.stop()
            })
        }
    }

    const stopCameraStream = () => {
        if (COMTRUEVAR.debugModeComtrue) {
            console.log('[ComtrueCamera.stopCameraStream] START')
        }
        stop()
        stopTrack()
    }

    const cameraSettings = async (
        video,
        canvas,
        user,
        useWebSocket,
        socketMessageSendType,
        callbackFunction,
        cardType
    ) => {
        if (COMTRUEVAR.debugModeComtrue) {
            console.log('[ComtrueCamera.cameraSettings] START')
            console.log('cameraSettings!!')
        }

        // COMTRUEWsCommon.connector(useWebSocket, socketMessageSendType);

        setTimeout(async () => {
            try {
                if (COMTRUEVAR.debugModeComtrue) {
                    console.log('COMTRUEEncryptUtils.importRsaKeys start ..')
                }
                await play(video, canvas, user)
                const data = await COMTRUEEncryptUtils.importRsaKeys()

                if (COMTRUEVAR.debugModeComtrue) {
                    console.log(
                        'COMTRUEEncryptUtils.importRsaKeys next .. ' + data
                    )
                }

                if (data.includes('success')) {
                    // [26.01.23] IBK 환경에서만 사용하는 소스
                    //카메라 로드후 화면 전환
                    const ibkScreen = document.getElementById('ibkScreen')
                    const comtrueScreen =
                        document.getElementById('comtrueScreen')

                    ibkScreen.style.display = 'none'
                    comtrueScreen.style.display = ''
                    callbackFunction(cardType)
                } else {
                    // fixme [2025.06.09] COMTRUECommon 함수 호출방식 수정
                    sendPostMessageClose()
                    closeThis(
                        '키 발급에 오류가 발생했습니다. 처음부터 다시 진행해주세요.'
                    )
                }
            } catch (error) {
                if (COMTRUEVAR.debugModeComtrue) {
                    console.log(error)
                }
                // fixme [2025.06.09] COMTRUECommon 함수 호출방식 수정
                sendPostMessageClose()
                closeThis(
                    '키 저장에 오류가 발생했습니다. 처음부터 다시 진행해주세요.'
                )
            }
        }, 3000)
    }

    return {
        cameraSettings,
        play,
        stop,
        change,
        done,
        draw,
        stopCameraStream,
        gotDevice,
        gotStream,
        settingInfo,
        stopTrack,
    }
}
export default useComtrueCamera
